import { useState } from "react";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import parse from "html-react-parser";
import { LinkToNewTab } from "../../../Elements/Link/Link.js";
import Button from "../../../Elements/Button/Button.js";
import { useModal } from "contexts/modalContext/modalContext.js";

const EmbedLimitOptionsModal = ({ typeOfModal = null }) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const typeModalDetails = {
    "num-forms-limit": {
      title: "not-premium-forms-limit-title",
      text: "not-premium-forms-limit-text",
    },
    "before-share-need-active-page": {
      title: "try-share-page-not-active-title",
      text: "try-share-page-not-active-text",
    },
    "before-share-need-active-page-not-premium": {
      title: "try-share-page-not-active-title",
      text: "try-share-page-not-active-text",
    },
    "only-one-form-will-display": {
      title: "only-one-form-will-display-title",
      text: "only-one-form-will-display-text",
    },
    "before-share-num-forms-limit": {
      title: "try-share-not-premium-title",
      text: "try-share-not-premium-text",
    },
    "embed-expired": {
      title: "embed-expired-title",
      text: "embed-limit-title-text-modal",
    },
    "embed-limit": {
      title: "embed-limit-title",
      text: "embed-limit-title-text-modal",
    },
    "business-premium": {
      title: "business-premium-limit-title",
      text: "business-premium-limit-text",
    },
    "not-available": {
      title: "not-available-title",
      text: "not-available-text",
    },
  };
  const [title, setTitle] = useState(
    typeModalDetails[typeOfModal || "embed-limit"].title
  );
  const [text, setText] = useState(
    typeModalDetails[typeOfModal || "embed-limit"].text
  );
  //embed-expired-text
  return (
    <div className="embed-limit-options-modal">
      <div className="title">
        <div className="icon-image-div">
          <Icon name={"jform-black"} />
        </div>
        <span>JUMBOforms</span>
      </div>
      <div className="body-content">
        <div className="title">{getTextByKey(title)}</div>
        <div className="text">{parse(getTextByKey(text))}</div>
        {typeOfModal === "before-share-need-active-page" ? (
          <div className="ok-button-embed-forms">
            <Button className="embed-button" onClick={() => closeModal()}>
              {getTextByKey(
                typeOfModal === "before-share-need-active-page"
                  ? "ok"
                  : "see-plans"
              )}
            </Button>
          </div>
        ) : (
          <LinkToNewTab page={"plans"} isNewTab>
            <Button className="embed-button">
              {getTextByKey(
                typeOfModal === "before-share-need-active-page"
                  ? "ok"
                  : "see-plans"
              )}
            </Button>
          </LinkToNewTab>
        )}
      </div>
    </div>
  );
};

export default EmbedLimitOptionsModal;
